/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from "react";
import styled, {css} from "styled-components";
import PropTypes from "prop-types";

import {Spinner} from "components";
import {BackIcon} from "components/commons";

import {WealthyEnv} from "helpers";

const propTypes = {
  pushUrlDomain: PropTypes.string.isRequired,
  step: PropTypes.number.isRequired,
  updateStep: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired
};

import {
  CardDetails
} from "./component";


const OnboardingQuestions = ({
  disableHandler,
  formData,
  handleGoBack,
  indianCityList,
  isLoading,
  isUpdatingAnswer,
  metaData,
  questions,
  setFormData,
  setIsUpdatingAnswer,
  showBackButton,
  step,
  onSubmitAnswers,
  userData
}) => {
  const isQuestionPresent = !!questions.length > 0;
  const isNextStagePresent = metaData?.next && metaData.next.length > 0;
  return (
    <>
      {
        isLoading ? (
          <LoaderContainer>
            <Spinner size="5rem" />
          </LoaderContainer>
        ) : (
          <>
            {
              isQuestionPresent && (
              <>
                <HeaderContainer>
                  <BackIcon
                    showBackButton={showBackButton}
                    onClickHandler={() => handleGoBack()}
                  />
                  {/* <Button className="close" href="#">
                    <span>+</span>
                  </Button> */}
                  <ProgressBarWrapper>
                    <PercentageText>{metaData?.completionPercentage}%</PercentageText>
                    <ProgressBarContainer>
                      <Progress percentage={metaData?.completionPercentage || 0} />
                    </ProgressBarContainer>
                  </ProgressBarWrapper>
                </HeaderContainer>
                <ContentContainer>
                  <Heading className="title">
                    {/* <span className="step">Step {metaData.level + 3}:&nbsp;</span> */}
                    {metaData.title}</Heading>
                  <SubText>{metaData.subTitle}</SubText>
                  <QuestionsContainer>
                    {
                      questions.map((eachQuestion, index) => {
                        return (
                          <CardDetails
                            formData={formData}
                            indianCityList={indianCityList}
                            isUpdatingAnswer={isUpdatingAnswer}
                            key={index}
                            question={eachQuestion}
                            questionTitle={eachQuestion.question.title}
                            setFormData={setFormData}
                            setIsUpdatingAnswer={setIsUpdatingAnswer}
                          />
                        );
                      })
                    }
                  </QuestionsContainer>
                  {
                    isNextStagePresent ?
                      <ButtonContainer
                        isDisabled={disableHandler()}
                        onClick={onSubmitAnswers}
                      >
                    Continue
                      </ButtonContainer> :
                      <ButtonContainer
                        isDisabled={disableHandler()}
                        onClick={onSubmitAnswers}
                      >
                   Submit
                      </ButtonContainer>

                  }
                </ContentContainer>
                </>
              )
            }
          </>
        )
      }
    </>
  );
};


const ThankYouContentContainer = styled.div`
  position: absolute;
  display: block;
  line-height: 1.8;
  width: 820px;
  height: 600px;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  box-shadow: 0px 12px 24px rgba(0,0,0,0.2);
  border-radius: 2.4rem;
  background-color: #fff;
  color: #34495E;
  overflow-y:auto;

  @media (max-width: 768px) {
    width: 100%;
    height: 80%;
    padding: 0;
  }
`;

const LoaderContainer = styled.div`
  /* min-height: calc(100vh - 20rem); */
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonContainer = styled.div`
  color: #f9f9f9;
  border-radius: 12px;
  background-color: #6725f4;
  font-size: 1.8rem;
  padding-top: 1rem;
  height: 5rem;
  text-align: center;
  width: 20%;
  margin: 8rem auto 0;

  :hover {
    cursor: pointer;
    transition: transform 100ms linear;
    transform: scale(1.02);
  }

  ${props =>
    props.isDisabled === true &&
    css`
      background-color: #ececec;
      color: #a1a1a1;
      pointer-events: none;
      :hover {
        cursor: default;
      }
    `}

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Button = styled.a`
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  background-color: #ededed;
  border-radius: 50%;
  transform: rotate(45deg);
  font-size: 3rem;
  text-align: center;
  outline: 0;
  height: 4rem;
  width: 4rem;
  >span {
    position: absolute;
    top: 50%;
    left: 50%;
    color: #6c6c6c;
    transform: translate(-50%, -50%);
  }
  :hover {
    background-image: linear-gradient(to bottom,#efefef 0%,#f5f5f5 100%);
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  }
`;

const ContentContainer = styled.div`
    margin-top: 0rem;
  @media (max-width: 768px) {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const Heading = styled.div`
  text-align: center;
  font-family: MavenPro;
  font-size: 2.8rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #6c6c6c;

  @media(max-width: 768px) {
    width: 100%;
    font-size: 2.3rem;
    margin-top: 4rem;
    line-height: 1.4;
  }
`;

const SubText = styled.div`
  font-size: 1.8rem;
  text-align: center;
  margin-top: 2rem;
  line-height: 1.43;

  @media (max-width: 768px) {
    display: none;
  }
`;

const QuestionsContainer = styled.div`
  margin-top: 3rem;
`;

const ProgressBarWrapper = styled.div`
    width: 120px;
    position: relative;
    margin-bottom: 1.5rem;
`;


const ProgressBarContainer = styled.div`
  width: 100%;
  height: 0.6rem;
  background-color: #ececec;
  border-radius: 10px;
  position: absolute;
`;

const PercentageText = styled.div`
    display: flex;
    width: 100%;
    justify-content: end;
    font-size: 1.4rem;
`;

const Progress = styled.div`
  width: ${props => props.percentage || 0}%;
  height: 100%;
  background-color: #6725f4;
  border-radius: 10px;
  transition: width 0.3s ease;
`;




OnboardingQuestions.propTypes = propTypes;

export default OnboardingQuestions;
